import iconFile from 'icons/iconPDF.png'
import styles from "./listFiles.module.css"
import DeleteIcon from 'icons/remove.svg'
import { IconButton } from 'entities/IconButton'
import { FileStoreManipulationService } from 'shared/docs/services/file-store-manipulation-service'

const fileStoreManipulationService = FileStoreManipulationService()

export const ListFiles = ({
    fileStores,
    onDeleteClick
}: any) => {
    console.debug('fileStores: ', fileStores)
    const getFile = async (id: string, name: string) => {
        try {
            // Получаем PDF по ID
            const response = await fileStoreManipulationService.getFileData(id);
            const blob = response.file
            
            // Проверяем, что получен корректный Blob
            if (!(blob instanceof Blob)) {
                console.error('Некорректный тип данных');
                return;
            }

            const pdfBlob = blob.slice(0, blob.size, 'application/pdf');
        
            // Проверка MIME-типа файла
            if (pdfBlob.type !== 'application/pdf') {
                console.warn('Файл не является PDF');
                return;
            }
            
    
            // Создаем URL для PDF
            const pdfUrl = URL.createObjectURL(pdfBlob);
    
            // Кроссплатформенный метод открытия PDF
            const openPdf = () => {
                // Для мобильных устройств используем window.open
                const newWindow = window.open(pdfUrl, '_blank');
                
                // Дополнительная проверка для iOS/Android
                if (newWindow) {
                    newWindow.focus();
                } else {
                    // Если всплывающее окно заблокировано
                    window.location.href = pdfUrl;
                }
            }
    
            // Открываем PDF
            openPdf();
    
            // Освобождаем ресурсы
            setTimeout(() => URL.revokeObjectURL(pdfUrl), 100);
    
        } catch (error) {
            console.error('Ошибка при открытии PDF:', error);
        }
    }

    return <>
        {fileStores.map((file: any) => <div className={styles.File}>
            <div className={styles.NameFile} onClick={() => getFile(file.id, `${file.name}.${file.type}`)}>
                <img src={iconFile} alt={""}/>
                <div>{`${file.name}.${file.type}`}</div>
            </div>
            
            <IconButton icon={DeleteIcon} onClick={() => onDeleteClick(file.id)} />
        </div>)}
    </>
}